import { useMutation, useQuery } from "@apollo/client";
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Text,
  useColorMode,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";

import { useUnauthorizedAction } from "../../../services/hooks/useUnauthorizedAction";

import { TableConsultation } from "./TableConsultation";
import { useForm } from "react-hook-form";
import moment from "moment";
import { MessageError } from "../../../shared/MessageError";

import { CREATE_SHIPMENT } from "../../../services/graphql/mutation/Shipment";
import { MessageSuccess } from "../../../shared/MessageSuccess";
import { IConsultationProduct } from "../../../services/graphql/ConsultationProduct";
import { CONSULTATION_PRODUCTS_ADMIN } from "../../../services/graphql/query/ConsultationProduct";
import { IProduct } from "../../../services/graphql/Product";
import { NEW_RESPONSE_PRODUCT } from "../../../services/graphql/mutation/ConsultationProduct";

export const Consultation = () => {
  const { colorMode } = useColorMode();
  const [loading, setLoading] = useState<boolean>(false);
  const [dataConsultation, setDataConsultationActive] = useState<
    IConsultationProduct[]
  >([]);

  const [dataConsultationWithoutResponse, setDataConsultationWithoutResponse] =
    useState<IConsultationProduct[]>([]);
  const [formResponseConsultationVisible, setFormResponseConsultationVisible] =
    useState<boolean>(false);
  const [modalViewProductVisible, setModalViewProductVisible] =
    useState<boolean>(false);
  const [productsConsultation, setProductsConsultation] = useState<IProduct>();
  const [consultationToResponse, setConsultationToResponse] =
    useState<IConsultationProduct>();

  const [responseConsultation] = useMutation(NEW_RESPONSE_PRODUCT);
  const [loadingButtons, setloadingButtons] = useState<boolean>(false);
  const { fetchMore } = useQuery(CONSULTATION_PRODUCTS_ADMIN, {
    variables: {
      filter: {},
    },
  });
  const { action } = useUnauthorizedAction();
  const toast = useToast();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const unauthorized = useCallback(() => {
    action();
  }, []);

  const consultationProducts = () => {
    setLoading(true);
    fetchMore({
      variables: {
        filter: {},
      },
    })
      .then((dataConsultation) => {
        const { data } = dataConsultation;
        const { consultation_products } = data;

        setDataConsultationActive(() => consultation_products);
        setDataConsultationWithoutResponse(() =>
          consultation_products.filter((ele: any) => !ele.response)
        );
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    consultationProducts();
  }, []);

  const onSubmitResponse = (values: any) => {
    setloadingButtons(true);
    responseConsultation({
      variables: {
        input: {
          consultation_product_id: consultationToResponse?.id,
          response: values.response,
        },
      },
    })
      .then(async () => {
        toast({
          duration: 2500,
          position: "bottom",
          render: () =>
            MessageSuccess({
              title: "Bien hecho!",
              description: "El envío se registró exitosamente!.",
            }),
        });
        consultationProducts();
        setFormResponseConsultationVisible(false);
      })
      .catch((error) => {
        if (error.message !== "Unauthorized") {
          toast({
            duration: 2500,
            position: "top",
            render: () =>
              MessageError(
                "Ocurrió un error al crear su envío. Por favor intente nuevamente."
              ),
          });
        } else {
          unauthorized();
        }
      })
      .finally(() => {
        setloadingButtons(false);
      });
  };

  return (
    <>
      {loading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <>
          <Flex flexDirection={"column"}>
            <Tabs isFitted variant="enclosed">
              <TabList mb="1em">
                <Tab>Todos las consultas</Tab>
                <Tab>Consultas sin respuesta</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  {dataConsultation.length ? (
                    <>
                      <TableConsultation
                        loadingButtonsOp={loadingButtons}
                        dataConsultation={dataConsultation}
                        onClickResponse={(consultation) => {
                          setConsultationToResponse(consultation);
                          setFormResponseConsultationVisible(true);
                        }}
                        onClickViewProducts={(products) => {
                          setProductsConsultation(products);
                          setModalViewProductVisible(true);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Center>
                        <>
                          <p>
                            <Tag>NO TIENES CONSULTAS &#128532;</Tag>
                          </p>
                        </>
                      </Center>
                    </>
                  )}
                </TabPanel>
                <TabPanel>
                  {dataConsultationWithoutResponse.length ? (
                    <>
                      <TableConsultation
                        loadingButtonsOp={loadingButtons}
                        dataConsultation={dataConsultationWithoutResponse}
                        onClickResponse={(consultation) => {
                          setConsultationToResponse(consultation);
                          setFormResponseConsultationVisible(true);
                        }}
                        onClickViewProducts={(products) => {
                          setProductsConsultation(products);
                          setModalViewProductVisible(true);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Center>
                        <>
                          <p>
                            <Tag>
                              NO TIENES CONSULTAS SIN RESPONDER &#128532;
                            </Tag>
                          </p>
                        </>
                      </Center>
                    </>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </>
      )}
      <Modal
        onClose={() => {
          setModalViewProductVisible(false);
        }}
        isOpen={modalViewProductVisible}
        size={"lg"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <Flex
              shadow={"inner"}
              direction={"column"}
              p={4}
              borderRadius="lg"
              borderColor={colorMode === "light" ? "gray.200" : "gray.700"}
              borderWidth={"1px"}
              h="80vh"
              boxShadow={"inner"}
            >
              <VStack
                spacing={"5px"}
                direction={"row"}
                overflowY="auto"
                className="container-line-cart"
                p={2}
              >
                {productsConsultation ? (
                  <>
                    <Box
                      p={4}
                      display={"flex"}
                      flexDirection={{ base: "column", sm: "row" }}
                      alignItems={"center"}
                      minH={"500px"}
                      w="100%"
                      borderColor={
                        colorMode === "light" ? "gray.800" : "gray.100"
                      }
                      justifyContent="center"
                      h="auto"
                    >
                      <Flex
                        justifyContent={"center"}
                        direction={{ base: "column" }}
                        alignItems="center"
                      >
                        {productsConsultation.url_image ? (
                          <Image
                            boxSize="150px"
                            objectFit="cover"
                            src={productsConsultation.url_image}
                            alt="Dan Abramov"
                          />
                        ) : null}

                        <Text my={5} fontWeight={"bold"}>
                          {productsConsultation.name}
                        </Text>
                      </Flex>
                      <Box
                        display={"flex"}
                        alignItems="center"
                        justifyContent={"center"}
                        flexDirection={{ base: "column", sm: "row" }}
                      >
                        <Text
                          mb={{ base: "5px", sm: "0px" }}
                          mr={{ base: "0px", sm: "10px" }}
                          fontWeight={"bold"}
                        >
                          {" "}
                        </Text>
                      </Box>
                    </Box>
                    <Divider />
                  </>
                ) : (
                  <>
                    <p>
                      <Tag>NO PUDIMOS MOSTRARTE EL PRODUCTOS &#128532;</Tag>
                    </p>
                  </>
                )}
              </VStack>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal
        onClose={() => {
          setConsultationToResponse(undefined);
          setFormResponseConsultationVisible(false);
        }}
        isOpen={formResponseConsultationVisible}
        size={"lg"}
      >
        <ModalOverlay />
        <ModalContent p={8}>
          <ModalCloseButton />
          <ModalBody>
            <Heading mb={0} as={"h4"}>
              Responder consulta
            </Heading>

            <form
              onSubmit={handleSubmit(onSubmitResponse)}
              style={{ marginTop: "10px" }}
            >
              <FormLabel m={0}>Consulta</FormLabel>
              <Text m={0}>{consultationToResponse?.message}</Text>
              <FormControl isInvalid={errors.response}>
                <FormLabel>Respuesta</FormLabel>
                <Input
                  placeholder="Respuesta..."
                  id="response"
                  {...register("response", {
                    required: "Debe seleccionar una respuesta",
                  })}
                />
                <FormErrorMessage>
                  {errors.response && errors.response.message}
                </FormErrorMessage>
              </FormControl>
              <Button w={"100%"} mt={3} type="submit">
                Guardar
              </Button>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
